(function () {
	'use strict';

	angular.module('mx.components').directive('mxRightClick', mxRightClick);

	mxRightClick.$inject = ['$parse'];

	function mxRightClick($parse) {
		return function (scope, element, attrs) {
			element.bind('contextmenu', function (event) {
				scope.$apply(function () {
					event.preventDefault();

					var fn = $parse(attrs.mxRightClick);
					fn(scope, { $event: event, $scope: scope });
				});
			});
		};
	}
})();
